"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingsCategories = void 0;
var settingsCategories = [{
  id: 'profile',
  title: 'Company profile',
  url: '/settings/profile',
  pageId: 'COMPANYPROFILE'
}, {
  id: 'terms',
  title: 'Terms',
  url: '/settings/terms',
  pageId: 'PAYMENTTERMS'
}, {
  id: 'services',
  title: 'Services',
  url: '/settings/services',
  pageId: 'SERVICES'
}, {
  id: 'user-management',
  title: 'User management',
  url: '/settings/users',
  pageId: 'USERMANAGEMENT'
}, {
  id: 'delegate',
  title: 'Delegate',
  url: '/settings/delegates',
  usesNewSettings: true,
  pageId: 'DELEGATE'
}, {
  id: 'costallocations',
  title: 'Cost allocations',
  url: '/settings/costallocations',
  pageId: 'BUDGETSETTINGS'
}, {
  id: 'account',
  title: 'Account',
  url: '/settings/account'
}, {
  id: 'api-keys',
  title: 'API keys',
  url: '/settings/api-keys',
  pageId: 'APIKEYS',
  usesNewSettings: true
}];
exports.settingsCategories = settingsCategories;